import { faFileExclamation } from "@elynx/pro-solid-svg-icons";
import { Box, Typography, useTheme } from "@mui/material";
import { format } from "date-fns/format";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IObjectHistoryDiagnosticEventItem } from "../../queries/object-history/Common";
import { ObjectHistoryCard } from "./ObjectHistoryCard";
import { ObjectHistoryCardContent } from "./ObjectHistoryCardContent";
import { ObjectHistoryCardHeader } from "./ObjectHistoryCardHeader";
import { ObjectHistoryCardSubheader } from "./ObjectHistoryCardSubheader";
import { ObjectHistoryEventItemAvatar } from "./ObjectHistoryEventItemAvatar";
import { getEventEndSummaryText, getEventEndSynopsisText, getEventStartSynopsisText } from "./ObjectHistoryUtils";

export type ObjectHistoryDiagnosticEventProps = {
    item: IObjectHistoryDiagnosticEventItem;
    contextObject?: IeLynxObject;
};

export function ObjectHistoryDiagnosticEventItem({ item, contextObject }: ObjectHistoryDiagnosticEventProps) {
    const theme = useTheme();

    return (
        <ObjectHistoryCard>
            <ObjectHistoryCardHeader
                title={format(item.timestamp, "P pp")}
                avatar={<ObjectHistoryEventItemAvatar item={item} icon={faFileExclamation} />}
                subheader={
                    <ObjectHistoryCardSubheader
                        item={item}
                        createdBy={item.createdBy}
                        contextObject={contextObject}
                    />
                }
            >
            </ObjectHistoryCardHeader>
            <ObjectHistoryCardContent>
                {item.isStart
                    ? <Typography variant="body2">
                        {getEventStartSynopsisText(item)}
                        <Box component="span" style={{ fontWeight: "bold" }}>{`${item.ruleName}.`}</Box>
                    </Typography>
                    : <>
                        <Typography variant="body2">{getEventEndSynopsisText(item)}</Typography>
                        <Typography variant="body2">
                            <Box component="span" style={{ fontWeight: "bold" }}>
                                {item.ruleName}
                            </Box>
                            {getEventEndSummaryText(item)}
                        </Typography>
                    </>
                }
                {item.note &&
                    <Typography variant="body2" style={{ marginTop: theme.spacing(1) }}>
                        <span style={{ fontWeight: "bold" }}>Note:</span> {item.note}
                    </Typography>
                }
            </ObjectHistoryCardContent>
        </ObjectHistoryCard>
    );
}



